"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccordionList = _ref => {
  let {
    items = [],
    allowMultiple = false,
    defaultExpandedIndexes = []
  } = _ref;
  const [expanded, setExpanded] = React.useState(allowMultiple ? defaultExpandedIndexes : defaultExpandedIndexes[0] ?? false);
  const handleChange = index => (_, isExpanded) => {
    if (allowMultiple) {
      setExpanded(prev => isExpanded ? [...prev, index] : prev.filter(i => i !== index));
    } else {
      setExpanded(isExpanded ? index : false);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: items.map((item, index) => {
      const isExpanded = allowMultiple ? expanded.includes(index) : expanded === index;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Accordion.default, {
        expanded: isExpanded,
        onChange: handleChange(index),
        elevation: 0,
        disableGutters: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionSummary.default, {
          expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {}),
          sx: {
            px: 0,
            m: 0,
            '&.Mui-expanded': {
              minHeight: 'unset',
              m: 0
            },
            '& .MuiAccordionSummary-content': {
              m: 0
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
              m: 0
            }
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            fontSize: 14,
            fontWeight: 500,
            children: item.question
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDetails.default, {
          sx: {
            px: 0
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            fontSize: 12,
            color: "#585969",
            children: item.answer
          })
        })]
      }, index);
    })
  });
};
var _default = exports.default = AccordionList;